import { createFileRoute } from '@tanstack/react-router';
import { SandboxPage } from '../sandbox-page';

export const Route = createFileRoute('/')({ component: SandboxPage });
